import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AccountProduct } from '../models';

@Injectable()
export class AccountProductsService {
  private readonly accountsApiPrefix = '/api/accounts';
  private readonly accountProductsSubPath = 'accountproducts';

  constructor(private http: HttpClient) {}

  public getAccountProducts(accountId: string) {
    return this.http.get<AccountProduct[]>(
      `${this.accountsApiPrefix}/${accountId}/${this.accountProductsSubPath}`,
    );
  }

  public putAccountProducts(
    accountId: string,
    brandId: string,
    productId: string,
    accountProductId: string,
  ) {
    return this.http.put<AccountProduct>(
      `${this.accountsApiPrefix}/${accountId}/${this.accountProductsSubPath}/${brandId}/${productId}`,
      { accountProductId },
    );
  }
}
